<template>
  <el-tooltip :content="isMapTreeCollapse ? '맵 트리 펼치기' : '맵 트리 접기'" placement="top-start">
    <div class="map-tree-visible-btn" @click="onClick">
      <i class="far fa-chevron-right" :class="(isMapTreeCollapse ? 'show' : 'hide')"></i>
    </div>
  </el-tooltip>
</template>

<script>
import Base from '@/mixins/topologymap/base';
import { MapInfo } from '@/views/topologymap/js/maps';

export default {
  name: 'WMapTreeVisibleButton',
  components: {
  },
  mixins: [Base],
  data() {
    return {};
  },
  watch: {
    isMapTreeCollapse() {
      this.updateMapTreeCollapse(!this.isEditMode);
    },
  },
  mounted() {
    const isCollapse = localStorage.getItem('mapTreeCollapse') === 'true';

    if (this.isMapTreeCollapse === isCollapse) {
      this.updateMapTreeCollapse(false);
    } else {
      this.$store.commit('setMapTreeCollapse', localStorage.getItem('mapTreeCollapse') === 'true');
    }
  },
  methods: {
    getLeftEl() {
      return document.querySelector('.drag-content.horizontal-zone--content.horiozontal-zone--frame-side');
    },
    getRightEl() {
      return document.querySelector('.drag-content.page.horizontal-zone--content.horiozontal-zone--frame-main');
    },
    updateMapTreeCollapse(animate) {
      const leftEl = this.getLeftEl();
      const rightEl = this.getRightEl();

      if (leftEl && rightEl) {
        if (!animate) {
          if (this.isMapTreeCollapse) {
            leftEl.style.display = 'none';
            rightEl.style.width = 'calc(100% - 64px)';
          } else {
            leftEl.style.display = null;
            rightEl.style.width = null;
          }
        } else {
          if (this.isMapTreeCollapse) {
            leftEl.style.transition = 'all .3s';
            rightEl.style.transition = 'all .2s';
            leftEl.style.minWidth = 'auto';
            leftEl.style.width = '0px';
            rightEl.style.width = 'calc(100% - 64px)';
          } else {
            leftEl.style.transition = 'all .2s';
            rightEl.style.transition = 'all .3s';
            leftEl.style.display = null;
            leftEl.style.width = null;
            rightEl.style.width = null;
          }

          setTimeout(() => {
            leftEl.style.transition = null;
            rightEl.style.transition = null;
            if (!this.isMapTreeCollapse) {
              leftEl.style.minWidth = null;
            }

            const graph = MapInfo.getInstance(this).getGraph();
            const canvas = MapInfo.getInstance(this).getCanvas();

            if (graph && canvas) {
              graph.updateViewport();
              canvas.updateZoom();
            }
          }, 300);
        }
      }
    },
    onClick() {
      this.$store.commit('setMapTreeCollapse', !this.isMapTreeCollapse);
    },
  },
};
</script>

<style lang="scss">
.map-tree-visible-btn {
  position: absolute;
  top: 2.5px;
  left: 0;
  width: 30px;
  height: 30px;
  margin: 5px;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: rgba(60,64,67,0.08);
  }

  & > i {
    position: absolute;
    top: calc(50% - 6.5px);
    left: calc(50% - 3.25px);
    display: inline-block;
    transition: all .3s;
    transform-origin: center;

    &.hide {
      transform: rotate(180deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/monitoring/MapTreeVisibleButton.vue